import { render, staticRenderFns } from "./TermsOfServiceComponent.vue?vue&type=template&id=6192f8b6&scoped=true&"
import script from "./TermsOfServiceComponent.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfServiceComponent.vue?vue&type=style&index=0&id=6192f8b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6192f8b6",
  null
  
)

export default component.exports